// extracted by mini-css-extract-plugin
export default {"footer":"AuthFooter_footer__dBlHU"};